module.exports = __webpack_public_path__ + "img/mico.92da776.svg";